import { render, staticRenderFns } from "./dataFee.vue?vue&type=template&id=35ce9d7c&scoped=true&"
import script from "./dataFee.vue?vue&type=script&lang=js&"
export * from "./dataFee.vue?vue&type=script&lang=js&"
import style0 from "./dataFee.vue?vue&type=style&index=0&id=35ce9d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce9d7c",
  null
  
)

export default component.exports